<template>
    <v-container app :fluid="true" class="padding-top-0 pl-0 pr-0">
        <v-row justify="center">
            <v-col :md="3" :sm="6" cols="12" class="padding-top-0">
                <v-card class="summary-card-item summary-total">
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class="ma-3" size="40" tile>
                            <v-icon class="summary-text-green letra-blanca">fas fa-list-ol</v-icon>
                        </v-avatar>
                        <div>
                            <v-card-title class="headline">
                                <span class="mr-2 summary-title letra-blanca">Total:</span>
                                <span class="summary-amount letra-blanca">
                                    {{ total }}
                                </span>
                            </v-card-title>
                        </div>                        
                    </div>
                </v-card>
            </v-col>
            <v-col :md="3" :sm="6" cols="12" class="padding-top-0">
                <v-card class="summary-card-item summary-pendientes">
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class="ma-3" size="40" tile>
                            <v-icon class="summary-text-green letra-blanca">fas fa-cubes</v-icon>
                        </v-avatar>
                        <div>
                            <v-card-title class="headline">
                                <span class="mr-2 summary-title letra-blanca">Pendientes:</span>
                                <span class="summary-amount letra-blanca">
                                    {{ total_pendientes }}
                                </span>
                            </v-card-title>
                        </div>                        
                    </div>
                </v-card>
            </v-col>
            <v-col :md="3" :sm="6" cols="12" class="padding-top-0">
                <v-card class="summary-card-item summary-en-reparto">
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class="ma-3" size="40" tile>
                            <v-icon class="summary-text-red letra-blanca">fas fa-dolly</v-icon>
                        </v-avatar>
                        <div>
                            <v-card-title class="headline">
                                <span class="mr-2 summary-title letra-blanca">En reparto:</span>
                                <span class="summary-amount letra-blanca">
                                     {{ total_reparto }}
                                </span>
                            </v-card-title>
                        </div>                        
                    </div>
                </v-card>
            </v-col>
            <v-col :md="3" :sm="6" cols="12" class="padding-top-0">
                <v-card class="summary-card-item summary-pagado">
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class="ma-3" size="40" tile>
                            <v-icon class="summary-text-blue letra-blanca">far fa-money-bill-alt</v-icon>
                        </v-avatar>
                        <div>
                            <v-card-title class="headline">
                                <span class="mr-2 summary-title letra-blanca">Pagados:</span>
                                <span class="summary-amount letra-blanca">
                                    {{ total_pagados }}
                                </span>
                            </v-card-title>
                        </div>                        
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
    name: 'Summary',
    data () {
        return {
            total: 0,
            total_pendientes: 0,
            total_pagados: 0,
            total_reparto: 0,
            total_entregados: 0
        }
    },
    computed: {
        ...mapState('orders', [
            'summary'
        ])
    },
    methods: {
        ...mapActions('orders', [
            'getOrdersSummary'
        ]),
        totalOrders () {
            if (this.summary.length > 0) {
                let amount = 0;
                let amount_pendientes = 0;
                let amount_pagados = 0;
                let amount_reparto = 0;
                let amount_entregados = 0;
                this.summary.forEach(element => {
                    //amount = amount + element.total;

                    if (element.status == 'Registrado') {
                        amount_pendientes = amount_pendientes + element.total;
                    }
                    if (element.status == 'En reparto') {
                        amount_reparto = amount_reparto + element.total;
                    }
                    if (element.status == 'Entregado') {
                        amount_entregados = amount_entregados + element.total;
                    }
                    if (element.status == 'Pagado') {
                        amount_pagados = amount_pagados + element.total;
                    }
                    
                });

                amount = amount + amount_pendientes + amount_reparto + amount_entregados + amount_pagados;

                this.total = amount;
                this.total_pagados = amount_pagados;
                this.total_reparto = amount_reparto;
                this.total_pendientes = amount_pendientes;
                this.total_entregados = amount_entregados;
            }
        },
        async getAmountSummary () {
            await this.getOrdersSummary();
            this.totalOrders();
        }
    },
    created () {
        this.getAmountSummary();
    }

}
</script>

<style>

.summary-card-item{
    height: 70px;
}

.summary-card{
    border-radius: 30px !important;
    height: 130px;
    cursor: pointer;
}

.summary-icon{
    padding-left: 30px;
    padding-top: 15px;
}

.summary-text-green{
    color: #43a047 !important;
}

.summary-text-orange{
    color: #fb8c00 !important;
}

.summary-text-red{
    color: #e53935 !important;
}

.summary-text-blue{
    color: #00acc1 !important;
}

.summary-title{
    font-weight: bold;
    font-size: .99rem;
    text-transform: uppercase;
}

.summary-amount{
    font-weight: bold;
    font-size: 1.1rem;
    color: #726E6E !important;
}

.summary-total{
    /*background-color: #2196F3 !important;*/
    /*background: linear-gradient(60deg,#2196F3,#00acc1)!important;*/
    /*background: rgb(33,150,243);
    background: linear-gradient(90deg, rgba(33,150,243,0.9447129193474265) 0%, rgba(16,88,145,1) 100%);*/
    background-color: #3949AB !important;
}

.summary-pendientes{
    /*background-color: #FFC107 !important;*/
    /*background: linear-gradient(60deg,#ffa726,#fb8c00)!important;*/
    /*background: rgb(255,193,7);
    background: linear-gradient(90deg, rgba(255,193,7,0.919502835313813) 0%, rgba(142,110,15,1) 100%);*/
    background-color: #FFB300 !important;
}

.summary-en-reparto{
    /*background-color: #F44336 !important;*/
    /*background: linear-gradient(60deg,#ef5350,#e53935)!important;*/
    /*background: rgb(244,67,54);
    background: linear-gradient(90deg, rgba(244,67,54,0.919502835313813) 0%, rgba(138,23,14,1) 100%);*/
    background-color: #F44336 !important;
}

.summary-pagado{
    /*background-color: #4CAF50 !important;*/
    /*background: linear-gradient(60deg,#66bb6a,#43a047)!important;*/
    /*background: rgb(76,175,80);
    background: linear-gradient(90deg, rgba(76,175,80,0.8970938717283788) 0%, rgba(14,134,19,1) 100%);*/
    background-color: #4CAF50 !important;
}

.letra-blanca{
    color: #ffffff !important;
}
</style>